<div id="tumbler-wrapper" class="tumbler-wrapper mt-20" (click)="changeMode()">
    <div id="tumbler" class="tumbler"></div>
    <img src="{{ images.darkMode.sun }}" height="15" width="15" alt="sun" />
    <img src="{{ images.darkMode.moon }}" height="15" width="15" alt="moon" />
</div>